export default "__VITE_ASSET__ClMz_3Ez__"